import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { jsx as _jsx } from "react/jsx-runtime";
function IssueDescriptionCell({
  crmObject
}) {
  const errorTags = getPropertyValue(crmObject, PROPERTIES.ERROR_TAGS);
  const errorTagsArray = errorTags ? errorTags.split(';') : [];
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: errorTagsArray.map(tag => {
      const message = `email-management.table.errorTags.${tag}.text`;
      if (['blocked', 'in_review', 'critsit_20250312'].includes(tag)) {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link: props => {
              return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
                external: true,
                children: props.children
              }));
            }
          },
          message: `email-management.table.errorTags.${tag}.text_jsx`
        }, tag);
      } else if (isValidI18nKey(message)) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: message
        }, tag);
      }
      return '-';
    })
  });
}
export default IssueDescriptionCell;